import { dataURLtoFile, getExtFromUrl } from 'utils/images';
import { generateUUID } from 'utils/general';

export const extractImages = (htmlString) => {
  /* eslint-disable-next-line no-undef */
  const parser = new DOMParser();
  const document = parser.parseFromString(htmlString, 'text/html');
  const images = document.getElementsByTagName('IMG');
  return images;
};

export const handleFileFromURL = (url, callback, filename) => {
  fetch(url, {
    method: 'GET',
    cache: 'no-cache',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  /* eslint-disable-next-line no-useless-return */
  .then((response) => response.blob(), () => { return; })
  .then((blob) => {
    // The above fetch can fail due to CORS issues. If it does, exit early.
    if (!blob) return;
    // Needed to generate a file name.
    const ext = getExtFromUrl(url);
    // create dataUrl from blob
    /* eslint-disable-next-line no-undef */
    const a = new FileReader();
    a.onload = (e) => { runCallbackWithDataURL(e.target.result, filename ?? `${generateUUID()}${ext}`, callback); };
    a.readAsDataURL(blob);
  });
};

const runCallbackWithDataURL = (dataUrl, filename, callback) => {
  const file = dataURLtoFile(dataUrl, filename);
  callback(file);
};

export const renameFilesInFilelist = (files) => {
  const fileList = [];
  /* eslint-disable-next-line */
  for (const file of files) {
    // The file should be from a dataTransfer in which the filename should be simple and not have
    // a bunch of edge cases to worry about.
    const ext = file.name.split('.').pop();
    const newFile = new File([file], `${generateUUID()}.${ext}`, {
      type: file.type,
      lastModified: file.lastModified,
    });
    fileList.push(newFile);
  }
  return fileList;
};
